import CameraIcon from '../../../../images/camera.svg?component';
import ROUTE_NAMES from '../../routeNames';
import SECTION_NAMES from '../../sectionNames';
import { usePermissionsStore } from '@/vue/stores/permissions';

const meta = {
    title: SECTION_NAMES.ROOMS_AND_DEVICES,
    permissions: (): string[] => [usePermissionsStore().allPermissions.adminRooms],
    icon: CameraIcon,
};

const AdminCameraView = () => import('../../../views/admin/AdminDevice/AdminCameraView.vue');

export default [
    {
        path: 'camera/new',
        name: ROUTE_NAMES.ADMIN_CAMERA_NEW,
        component: AdminCameraView,
        meta: { new: true, ...meta },
    },
    {
        path: 'camera/edit/:id',
        name: ROUTE_NAMES.ADMIN_CAMERA_VIEW,
        component: AdminCameraView,
        meta: { new: false, ...meta },
    },
];
